import { render } from "./notice-pattern-list.vue?vue&type=template&id=c07cff04"
import script from "./notice-pattern-list.vue?vue&type=script&lang=js"
export * from "./notice-pattern-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__